import { FC } from "react";

import { AssessmentGradingLastPanel } from "./AssessmentGradingLastPanel";

import { ACCESS_ID_QUERY_PARAM, SUBMISSION_ID_QUERY_PARAM } from "components/constants";
import { PageType } from "components/server-types";
import { useAssessedCountDataWithNotSubmitted } from "utils/assessment";
import { useQueryParamsActions } from "utils/routing";

interface AssessmentSummaryMainPanelProps {
  page: PageType;
}

export const AssessmentSummaryMainPanel: FC<AssessmentSummaryMainPanelProps> = ({ page }) => {
  const { deleteQueryParams } = useQueryParamsActions();
  const assessedCountData = useAssessedCountDataWithNotSubmitted(page);
  const onBack = () => {
    deleteQueryParams([ACCESS_ID_QUERY_PARAM, SUBMISSION_ID_QUERY_PARAM]);
  };

  return (
    <div className="worksheet-page flex flex-col">
      <div className="flex h-full items-start justify-center">
        <div className="extended-page-block-width">
          <AssessmentGradingLastPanel
            assessedCountData={assessedCountData}
            page={page}
            hideButtons
            onBack={onBack}
          />
        </div>
      </div>
    </div>
  );
};
